import store from "redux/Store";
import { makeRandomId } from "util/CommonFunc";

export const _newMessage = (
  type,
  attachments = [],
  subject = "new message",
  text = "",
  tousers = [],
  togroups = [],
  cStatus = null
) => {
  const {
    user: { email },
  } = store.getState();

  return {
    type: type,
    id: "",
    attachments: attachments,
    subject: subject,
    body: text,
    tousers: tousers,
    togroups: togroups,
    by: email,
    at : new Date().toISOString(),
    cStatus : cStatus
  };
};

export const _newContentMessage = (
  type,
  attachments = [],
  subject = "new message",
  text = "",
  tousers = [],
  togroups = [],
  cStatus = null,

  cTitle = "",
  cArtist = "",
  cContentType = null,
  cPriority = null,
  cProposedUsage = null,

) => {
  const {
    user: { email },
  } = store.getState();

  return {
    type: type,
    id: "",
    attachments: attachments,
    subject: subject,
    body: text,
    tousers: tousers,
    togroups: togroups,
    by: email,
    at : new Date().toISOString(),
    cStatus : cStatus,
    refNo: makeRandomId(), 
    cTitle : cTitle,
    cArtist : cArtist,
    cContentType : cContentType,
    cPriority : cPriority,
    cProposedUsage : cProposedUsage,
  };
};

export const _newReply = (parent, text) => {
  const {
    user: { email },
  } = store.getState();

  let tousers = parent.tousers.filter((v) => v !== email);

  let togroups = parent.togroups;

  let by = parent.by || parent.createdBy;

  if (by !== email && !tousers.find((v) => v === by)) tousers.push(by);
 

  return {
    type: parent.type,
    parent: parent.id,
    id: "",
    attachments: [],
    subject: "Re. " + parent.subject,
    body: text,
    tousers: tousers,
    togroups: togroups,
    by: email,
    at : new Date().toISOString()
  };
};

export const _newContentReply = (parent, text, attachments, linkedId="") => {
  const {
    user: { email },
  } = store.getState();

  let tousers = parent.tousers.filter((v) => v !== email);

  let togroups = parent.togroups;

  let by = parent.by || parent.createdBy;

  if (by !== email && !tousers.find((v) => v === by)) tousers.push(by);
 

  return {
    type: parent.type,
    parent: parent.id,
    id: "",
    attachments: attachments || [],
    subject: "Re. " + parent.subject,
    body: text,
    tousers: tousers,
    togroups: togroups,
    by: email,
    at : new Date().toISOString(),
    linkedId : linkedId
  };
};
